<template>
  <div id="app">

    <div class="row no-gutters">
      <div class="col-sm-3">
        <div class="toolbox">
          <div class="sticky-top bg-white shadow-sm p-2">
            <div class="form-group d-flex">
              <label for="cityName" class="mr-2 col-form-label text-right">縣市</label>
              <!--等寬-->
              <div class="flex-fill">
              <!--切換縣市時移除上次的地標-->
                <select id="cityName" class="form-control"
                v-model="select.city" @change="removeMarker()">
                  <option value="">-- Select One --</option>
                  <option :value="c.CityName" v-for="c in cityName" :key="c.CityName">
                  {{ c.CityName }}
                  </option>
                </select>
              </div>
            </div>

        <div class="form-group d-flex">
            <label for="area" class="mr-2 col-form-label text-right">地區</label>
            <div class="flex-fill">
              <select id="area" class="form-control" v-if="select.city.length"
                v-model="select.area" @change="removeMarker();updateMap()">
                <option value="">-- Select One --</option>
                <!--find 回傳第一個滿足函式的元素值-->
                <option :value="a.AreaName"
                  v-for="a in cityName.find((city) => city.CityName === select.city).AreaList"
                  :key="a.AreaName">
                  {{ a.AreaName }}
                </option>
              </select>
            </div>
        </div>

        <div class="form-group d-flex">
            <label for="area" class="mr-2 col-form-label text-right">藥局</label>
            <div class="flex-fill">
              <div class="input-group">
                <input class="form-control" type="text" v-model="searchText"
                  placeholder="Search" aria-label="Search" @input="search()">
              </div>
            </div>
        </div>
<!--
        <template v-for="(item, key) in filterData">
            <a class="list-group-item text-left" :key="key"
              v-if="item.properties.name === this.searchText"
              :class="{ 'highlight': item.properties.mask_adult || item.properties.mask_child}"
              @click="panTo(item)">
              <h3>{{ item.properties.name }}</h3>
              <p class="mb-0">
                成人口罩：{{ item.properties.mask_adult}} | 兒童口罩：{{ item.properties.mask_child}}
              </p>
              <p class="mb-0">地址：<a :href="`https://www.google.com.tw/maps/place/${item.properties.address}`"
                target="_blank" title="Google Map">
                {{ item.properties.address }}</a>
              </p>
            </a>
        </template> -->

        <p class="mb-0 small text-muted text-right">請選擇區域查看</p>
      </div>
      <ul class="list-group">
        <!-- <template>
          <a class="list-group-item text-left">
            <h3>藥局名稱</h3>
            <p class="mb-0">
              成人口罩：1 | 兒童口罩：2
            </p>
              <p class="mb-0">地址：<a href="https://www.google.com.tw/maps/place/..."
              target="_blank" title="Google Map">
              地址</a>
            </p>
          </a>
        </template> -->
        <template v-for="(item, key) in filterData">
            <a class="list-group-item text-left" :key="key"
              v-if=" searchText != ''"
              :class="{ 'highlight': item.properties.mask_adult || item.properties.mask_child}"
              @click="panTo(item)">
              <h3>{{ item.properties.name }}</h3>
              <p class="mb-0">
                成人口罩：{{ item.properties.mask_adult}} | 兒童口罩：{{ item.properties.mask_child}}
              </p>
              <p class="mb-0">地址：<a :href="`https://www.google.com.tw/maps/place/${item.properties.address}`"
                target="_blank" title="Google Map">
                {{ item.properties.address }}</a>
              </p>
            </a>
          </template>
        <template v-for="(item, key) in data">
            <a class="list-group-item text-left" :key="key"
              v-if="item.properties.county === select.city
                && item.properties.town === select.area && searchText === ''"
              :class="{ 'highlight': item.properties.mask_adult || item.properties.mask_child}"
              @click="panTo(item)">
              <h3>{{ item.properties.name }}</h3>
              <p class="mb-0">
                成人口罩：{{ item.properties.mask_adult}} | 兒童口罩：{{ item.properties.mask_child}}
              </p>
              <p class="mb-0">地址：<a :href="`https://www.google.com.tw/maps/place/${item.properties.address}`"
                target="_blank" title="Google Map">
                {{ item.properties.address }}</a>
              </p>
            </a>
          </template>
      </ul>
    </div>
  </div>

  <!--地圖-->
    <div class="col-sm-9">
      <div id="map"></div>
    </div>
  </div>
</div>
</template>

<script>
// 載入 leaflet 套件
import L from 'leaflet'
// 載入臺灣地區 JSON
import cityName from './assets/CityCountyData.json'

export default {
  name: 'home',
  // Vue 進階語法  () => ({})
  data: () => ({
    data: [],
    osmMap: {},
    cityName,
    select: {
      city: '新北市',
      area: ''
    },
    searchText: '',
    filterData: []
  }),
  methods: {
    updateMap () {
      const pharmacies = this.data.filter((pharmacy) => (
        pharmacy.properties.town === this.select.area))
      // console.log(pharmacies)
      pharmacies.forEach((pharmacy) => {
        // 解構，縮短變數名稱
        const { properties, geometry } = pharmacy
        // 圖標 icon
        // const greenIcon = L.icon({
        //   iconUrl: './assets/img/marker-icon-2x-green.png',
        //   iconSize: [25, 41],
        //   iconAnchor: [12, 41],
        //   popupAnchor: [1, -34],
        //   shadowUrl: './assets/img/marker-shadow.png',
        //   shadowSize: [41, 41],
        //   shadowAnchor: [12, 41]
        // })
        /* marker 建立地標 L.marker(latlng[], options{ icon: myIcon }).addTo(map).bindPopup(content).openPopup()
        addTO 加到圖層
        bindPopup 圖標加上說明(可用HTML語法)
        */
        L.marker([
          geometry.coordinates[1],
          geometry.coordinates[0]
        ]).addTo(this.osmMap).bindPopup(
        `<strong>${properties.name}</strong> <br>
        口罩剩餘：<strong>成人 - ${properties.mask_adult ? `${properties.mask_adult} 個` : '未取得資料'}/ 兒童 - ${properties.mask_child ? `${properties.mask_child} 個` : '未取得資料'}</strong><br>
        地址: <a href="https://www.google.com.tw/maps/place/${properties.address}" target="_blank">${properties.address}</a><br>
        電話: ${properties.phone}<br>
        <small>最後更新時間: ${properties.updated}</small>`, { closeOnClick: false })
      })
      this.panTo(pharmacies[0])
    },
    removeMarker () {
      this.osmMap.eachLayer((layer) => {
        // 如果圖層是 L.Marker 產生的話就移除，判斷某個建構式的 prototype 屬性是否存在另外一個要檢測物件的原型鏈上。
        if (layer instanceof L.Marker) {
          this.osmMap.removeLayer(layer)
        }
      })
    },
    // 顯示中心移動到選取的地點
    panTo (item) {
      // console.log(item)
      this.osmMap.panTo([item.geometry.coordinates[1], item.geometry.coordinates[0]])
      const greenIcon = L.icon({
        iconUrl: 'https://cdn.rawgit.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-green.png',
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
        shadowSize: [41, 41],
        shadowAnchor: [12, 41]
      })
      const { properties, geometry } = item
      L.marker([
        geometry.coordinates[1],
        geometry.coordinates[0]
      ], { icon: greenIcon }).addTo(this.osmMap).bindPopup(
        `<strong>${properties.name}</strong> <br>
        口罩剩餘：<strong>成人 - ${properties.mask_adult ? `${properties.mask_adult} 個` : '未取得資料'}/ 兒童 - ${properties.mask_child ? `${properties.mask_child} 個` : '未取得資料'}</strong><br>
        地址: <a href="https://www.google.com.tw/maps/place/${properties.address}" target="_blank">${properties.address}</a><br>
        電話: ${properties.phone}<br>
        <small>最後更新時間: ${properties.updated}</small>`, { closeOnClick: false }).openPopup()
    },
    // 藥局搜尋
    search () {
      this.removeMarker()
      if (this.searchText) {
        const filter = this.data.filter((item) => (
          item.properties.name === this.searchText))
        // console.log(filter)
        this.filterData = filter
        this.panTo(this.filterData[0])
        const { properties, geometry } = this.filterData[0]
        // 建立地標
        L.marker([
          geometry.coordinates[1],
          geometry.coordinates[0]
        ]).addTo(this.osmMap).bindPopup(
        `<strong>${properties.name}</strong> <br>
        口罩剩餘：<strong>成人 - ${properties.mask_adult ? `${properties.mask_adult} 個` : '未取得資料'}/ 兒童 - ${properties.mask_child ? `${properties.mask_child} 個` : '未取得資料'}</strong><br>
        地址: <a href="https://www.google.com.tw/maps/place/${properties.address}" target="_blank">${properties.address}</a><br>
        電話: ${properties.phone}<br>
        <small>最後更新時間: ${properties.updated}</small>`)
        this.osmMap.eachLayer((layer) => {
        // if (layer._zIndex === item.zIndex) {
        // console.log(([item.geometry.coordinates[1], item.geometry.coordinates[0]]))
          layer.openPopup()
        // }
        })
      }
    }
    // onMapClick () {
    //   L.popup()
    //     .setLatLng([23.010, 120.289])
    //     .setContent('獨立的訊息方塊。')
    //     .openOn(this.osmMap)
    // }
  },
  mounted () {
    // 用 axios 非同步取得藥局資料
    const api = 'https://raw.githubusercontent.com/kiang/pharmacies/master/json/points.json'
    this.$http.get(api).then((Response) => {
      // console.log(Response)
      this.data = Response.data.features
    })
    // 新增並顯示地圖 L.map(id, options)
    this.osmMap = L.map('map', {
      // center: [25.03, 121.55],
      center: [25.0085455, 121.4594333],
      zoom: 15
    })
    // 載入圖層到地圖(不然地圖會是空白) L.tileLayer(urlTemplate, options).addTo(map)
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png?{foo}', {
      foo: 'bar',
      attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>',
      maxZoom: 18
    }).addTo(this.osmMap)
    // 加上圖標
    // L.marker([25.0085455, 121.4594333]).addTo(this.osmMap)
    // 多邊形
    // L.polygon([
    //   [22.992, 120.289],
    //   [22.982, 120.299],
    //   [22.970, 120.267],
    //   [22.990, 120.267]
    // ]).addTo(this.osmMap)
    // 圓形
    // L.circle(
    //   [22.988, 120.220], // 圓心座標
    //   1000, // 半徑（公尺）
    //   {
    //     color: 'red', // 線條顏色
    //     fillColor: '#f03', // 填充顏色
    //     fillOpacity: 0.5 // 透明度
    //   }
    // ).addTo(this.osmMap)
    // 獨立訊息
    // L.popup()
    //   .setLatLng([23.010, 120.289])
    //   .setContent('獨立的訊息方塊。')
    //   .openOn(this.osmMap)
  }

}

</script>

<style lang="scss">
@import 'bootstrap/scss/bootstrap';

#map {
  // 給地圖高度滿版
  height: 100vh;
}
.highlight {
  background: #e9ffe3;
}
.toolbox {
  height: 100vh;
  overflow-y: auto;
  a {
    cursor: pointer;
  }
}

</style>
